import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts'

// Sample data - in production, this would come from the database
const sampleData = [
    { date: 'Mon', words: 1200, cliches: 8 },
    { date: 'Tue', words: 2400, cliches: 15 },
    { date: 'Wed', words: 1800, cliches: 12 },
    { date: 'Thu', words: 3200, cliches: 22 },
    { date: 'Fri', words: 2800, cliches: 18 },
    { date: 'Sat', words: 1600, cliches: 10 },
    { date: 'Sun', words: 2100, cliches: 14 },
]

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="glass-card px-4 py-3 shadow-xl">
                <p className="text-white font-medium mb-2">{label}</p>
                {payload.map((entry, index) => (
                    <p key={index} className="text-sm" style={{ color: entry.color }}>
                        {entry.name}: <span className="font-medium">{entry.value.toLocaleString()}</span>
                    </p>
                ))}
            </div>
        )
    }
    return null
}

export default function UsageChart({ data, period = 'week' }) {
    const chartData = data || sampleData

    return (
        <div className="glass-card p-6">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h3 className="text-lg font-semibold text-white">Usage Over Time</h3>
                    <p className="text-sm text-white/50">Words analyzed and clichés detected</p>
                </div>
                <div className="flex gap-2">
                    {['Day', 'Week', 'Month'].map((p) => (
                        <button
                            key={p}
                            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors
                         ${period === p.toLowerCase()
                                    ? 'bg-primary-500/20 text-primary-400'
                                    : 'text-white/50 hover:text-white hover:bg-white/5'}`}
                        >
                            {p}
                        </button>
                    ))}
                </div>
            </div>

            <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                        <defs>
                            <linearGradient id="colorWords" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#22d3ee" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#22d3ee" stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorCliches" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#a855f7" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#a855f7" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                        <XAxis
                            dataKey="date"
                            stroke="rgba(255,255,255,0.3)"
                            tick={{ fill: 'rgba(255,255,255,0.5)', fontSize: 12 }}
                        />
                        <YAxis
                            stroke="rgba(255,255,255,0.3)"
                            tick={{ fill: 'rgba(255,255,255,0.5)', fontSize: 12 }}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Area
                            type="monotone"
                            dataKey="words"
                            name="Words"
                            stroke="#22d3ee"
                            strokeWidth={2}
                            fill="url(#colorWords)"
                        />
                        <Area
                            type="monotone"
                            dataKey="cliches"
                            name="Clichés"
                            stroke="#a855f7"
                            strokeWidth={2}
                            fill="url(#colorCliches)"
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>

            {/* Legend */}
            <div className="flex items-center justify-center gap-6 mt-4 pt-4 border-t border-white/10">
                <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-primary-400" />
                    <span className="text-sm text-white/60">Words Analyzed</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-accent-400" />
                    <span className="text-sm text-white/60">Clichés Detected</span>
                </div>
            </div>
        </div>
    )
}
